import { createFileRoute } from "@tanstack/react-router";
import { requerirEdicionDeSolicitud } from "@/features/solicitudes/utils/guard-edicion";
import { proveedoresAgrupadosQueryOptions } from "@/features/proveedor/hooks/use-proveedores-agrupados";
import { ProveedorPage } from "@/features/proveedor/components/ProveedorPage";
import { solicitudQueryOptions } from "@/features/solicitudes/hooks/use-solicitud";
import { ErrorAlert, WizardPasoSkeleton } from "@/components/ui";

/**
 * Ruta `/solicitudes/$id/proveedor` · file delgado con loader que
 * precarga la solicitud y los grupos de proveedores en paralelo.
 */
export const Route = createFileRoute("/_authed-tw/solicitudes/$id/proveedor")({
  beforeLoad: requerirEdicionDeSolicitud,
  loader: ({ context: { queryClient }, params: { id } }) => Promise.all([queryClient.ensureQueryData(solicitudQueryOptions(id)), queryClient.ensureQueryData(proveedoresAgrupadosQueryOptions(id))]),
  component: ProveedorPage,
  pendingComponent: WizardPasoSkeleton,
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
